import { router } from 'expo-router'
import { useTranslation } from 'react-i18next'
import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import Page from '@shell/Page'

import Discounts from './Discounts'

export default function OrderDiscounts() {
  const { t } = useTranslation(['ui', 'modals'])

  return (
    <>
      <Page stage="order">
        <Discounts />
      </Page>
      <ButtonsFixed
        buttons={[
          {
            variant: 'filled',
            label: t('ui:checkout'),
            iconEnd: 'arrow-narrow-right',
            onPress: () => router.navigate('/order/billing'),
          },
        ]}
      />
    </>
  )
}
